import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { ActiveRateCodeModel } from '../models/reports/active-ratecode.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AuthGaurdService } from './auth-gaurd.service';

@Injectable({
    providedIn: 'root'
})
export class ActiveRateCodeService {

    private host = environment.apiUrl + "reports/activeratecode";
    public loggedinUser: string = '';
    mySalesChannelSet = new Set<string>();
    activeRateCodeModel = new ActiveRateCodeModel(0, 0, '', '', '', '', [], [],'','',null,null);

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        console.log('ActiveRateCodeService login name ', this.loggedinUser);
    }

    public getRateCodeDetails(corps:number[],sc:string,proid:number,dt: Date) {
      console.log("aaaaaa = "+corps+"-"+sc+"-"+proid+"-"+dt);
      const url = this.host + '/getactivecodedetails/' + corps +'/'+sc+'/'+proid+'/'+dt;
      console.log("url = "+url);
      return this.http.get<ActiveRateCodeModel[]>(url)
        .pipe(
          map((data: ActiveRateCodeModel[]) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError('Something went wrong!');
          })
        )
    }


    

    public getCorps() {
      const url = this.host + '/getcorps';
      return this.http.get<ActiveRateCodeModel[]>(url)
        .pipe(
          map((data: ActiveRateCodeModel[]) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError('Something went wrong!');
          })
        )
    }

    public getProducts() {
        let url = this.host + '/getproducts';
        return this.http.get<ActiveRateCodeModel[]>(url)
          .pipe(
            map((data: ActiveRateCodeModel[]) => {
              return data;
            }), catchError(error => {
              this.logger.info(' error ==> ', error);
              return throwError('Something went wrong!');
            })
          )
      }

      public getSalesChannels() {
        let url = this.host + '/getsaleschannels';
        return this.http.get<ActiveRateCodeModel[]>(url)
          .pipe(
            map((data: ActiveRateCodeModel[]) => {
              return data;
            }), catchError(error => {
              this.logger.info(' error ==> ', error);
              return throwError('Something went wrong!');
            })
          )
      }

     

}